import React from "react";
import PropTypes from "prop-types";

import SlideElectricMilesPortionForPhev from "../InputComponents/SlideElectricMilesPortionForPhev/SlideElectricMilesPortionForPhev";
import SlideMilesDrivenDaily from "../InputComponents/SlideMilesDrivenDaily/SlideMilesDrivenDaily"
import SlideMonthsOfOwnership from "../InputComponents/SlideMonthsOfOwnership/SlideMonthsOfOwnership";
import SelectPurchaseMethod from "../InputComponents/SelectPurchaseMethod/SelectPurchaseMethod";

const CostOfOwnershipOptions = ({ cars }) => {
  if (!cars || cars.length === 0) return null;

  return (
    <div className="input-well">
      <SelectPurchaseMethod />
      <SlideMilesDrivenDaily />
      <SlideElectricMilesPortionForPhev />
      <SlideMonthsOfOwnership />
    </div>
  );
};

CostOfOwnershipOptions.propTypes = {
  car: PropTypes.object,
};
export default CostOfOwnershipOptions;
